export { default as AccoladeCard } from './AccoladeCard';
